import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailIcon from "@mui/icons-material/Mail";
import axios from "axios";
const Setting = ({ setting, nep }) => {
  // console.log(setting);

  return (
    <>
      <div className="FooterItem wd35">
        <h3>
          {nep
            ? "गुहेश्वरी मर्चेन्ट बैंकिङ एण्ड फाइनान्स लिमिटेड"
            : "Guheshwori Merchant Banking and Finance Ltd."}
        </h3>
        <p>
          <LocationOnIcon fontSize="small" />
          {nep ? "हरिहरभवन, ललितपुर, नेपाल" : setting.address}
        </p>
        <p>
          <LocalPhoneIcon fontSize="small" />
          <span>{setting.telephone}</span>
        </p>
        <p>
          <MailIcon fontSize="small" />
          <span>{setting.email}</span>
        </p>
        <h4> {nep ? "बैंकिङ समय" : "Banking HOURS"} </h4>
        <p>
          {setting.opening_time} - {setting.closing_time}{" "}
          {nep ? " (सोमबार-शुक्रबार )" : "(MON-FRI)"}
        </p>
        {/* <p>
          {setting.opening_time_friday} - {setting.closing_time_friday}{" "}
          {nep ? "(शुक्रबार)" : "(Friday)"}
        </p> */}
      </div>
    </>
  );
};
export default Setting;
